import AdTypeMenu from './AdTypeMenu';

const AdTypeMenuDirective = (reactDirective, $state) => {
  return reactDirective(
    AdTypeMenu,
    undefined,
    {
      restrict: 'E'
    },
    {
      $state
    }
  );
};

AdTypeMenuDirective.$inject = ['reactDirective', '$state'];

export default AdTypeMenuDirective;
